
            const data = {"name":"icon-burger","data":{"viewBox":"0 0 20 16","data":"<path pid=\"0\" d=\"M1.498 1.6a.6.6 0 010-1.2h17a.6.6 0 110 1.2h-17zm0 6.5a.6.6 0 010-1.2h17a.6.6 0 110 1.2h-17zm0 7a.6.6 0 110-1.2h17a.6.6 0 110 1.2h-17z\" _fill=\"currentColor\"/>"}}
        
                module.exports = data
                